<script>
export default {
  name: "legal-entity"
};
</script>

<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss"></style>
